<script>
  import { onMount, onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';

  export let selected;

  $: selected && initializePlayer();

  const mute = () => {
    if (window.THEOplayer?.players?.length) {
      let player = window.THEOplayer.players
        .filter((e) => e.src)
        .find((e) => e.src.indexOf(selected.playlist[0].name) > -1);
      if (player) {
        player.muted = true;
      }
    }
  };

  const playVideo = () => {
    if (selected && selected.playlist) {
      let playlist = [...selected.playlist];
      const removeFirst = playlist.shift();
      let list = playlist.map((a) => {
        return {
          duration: '',
          id: a.name,
          image_url: '',
          title: '',
        };
      });
      window.playVideo({
        container: 'live',
        assetId: (removeFirst && removeFirst.name) || '',
        showAds: selected.ads || false,
        autoplay: selected.autoplay || false,
        loopPlaylist: true,
        playlist: JSON.stringify(list),
      });
    }
  };

  const initializePlayer = () => {
    playVideo();
    if (selected.autoplay) {
      setTimeout(() => {
        mute();
      }, 550);
    }
  };

  onMount(() => {
    if (!window.player) {
      initializePlayer();
    }
  });

  onDestroy(() => {
    window.player?.cease();
  });
</script>

<div class="padded-box" in:fade={{ duration: 200 }}>
  <div id="video_placeholder_live">
    <!--  svelte-ignore a11y-media-has-caption -->
    <video id="video_live" />
  </div>
</div>

<style>
  .padded-box {
    width: 100%;
    background: #000;
    padding-bottom: 56.25%;
    height: 0;
  }
</style>
